import {inject, injectable} from 'inversify';

import type {Expand} from '../../../../api/types';

import {
  foodDiaryExpandCommon,
  type FoodDiaryExpandFieldsCommon,
} from '../../../../api/foodDiary';
import {BaseExpandJrpc} from '../../../domain/Base/mappers/Base.expand.jrpc';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';

@injectable()
export class FoodDiaryExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = foodDiaryExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace FoodDiaryExpandJrpc {
  export type ExpandedFields = FoodDiaryExpandFieldsCommon;
}
